var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0266 9.03267C11.7466 9.30601 11.5866 9.69934 11.6266 10.1193C11.6866 10.8393 12.3466 11.366 13.0666 11.366H14.3333V12.1593C14.3333 13.5393 13.2066 14.666 11.8266 14.666H5.08663C5.29329 14.4927 5.47329 14.2793 5.61329 14.0393C5.85996 13.6393 5.99996 13.166 5.99996 12.666C5.99996 11.1927 4.80663 9.99935 3.33329 9.99935C2.70663 9.99935 2.12663 10.2194 1.66663 10.586V7.67269C1.66663 6.29269 2.79329 5.16602 4.17329 5.16602H11.8266C13.2066 5.16602 14.3333 6.29269 14.3333 7.67269V8.63269H12.9866C12.6133 8.63269 12.2733 8.77934 12.0266 9.03267Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 8.27288V5.22625C1.66663 4.43291 2.15329 3.72622 2.89329 3.44622L8.18663 1.44622C9.01329 1.13289 9.89996 1.74624 9.89996 2.6329V5.16623",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0392 9.31376V10.6871C15.0392 11.0538 14.7459 11.3538 14.3726 11.3671H13.0659C12.3459 11.3671 11.6859 10.8404 11.6259 10.1204C11.5859 9.70044 11.7459 9.30711 12.0259 9.03377C12.2726 8.78044 12.6126 8.63379 12.9859 8.63379H14.3726C14.7459 8.64712 15.0392 8.94709 15.0392 9.31376Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 8H9.33335",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 12.6667C6.00002 13.1667 5.86002 13.64 5.61335 14.04C5.47335 14.28 5.29335 14.4933 5.08669 14.6667C4.62002 15.0867 4.00669 15.3333 3.33335 15.3333C2.36002 15.3333 1.51335 14.8133 1.05335 14.04C0.806688 13.64 0.666687 13.1667 0.666687 12.6667C0.666687 11.8267 1.05335 11.0733 1.66669 10.5867C2.12669 10.22 2.70669 10 3.33335 10C4.80669 10 6.00002 11.1933 6.00002 12.6667Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04669 13.3598L2.63336 11.9531",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03333 11.9736L2.62 13.3803",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.a8aff831a0e312c2fcf751c4dcb2b90b.svg";
export { ForwardRef as ReactComponent };